export default __webpack_public_path__ + "static/media/angbao-bonus.aface339.webp";